import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export function LoadingSpinner({ tip = 'Đang tải dữ liệu...', minHeight = '300px' }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        width: '100%',
      }}
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 32, color: '#0284c7' }} spin />} />
      <div style={{ marginTop: 12, color: '#64748b', fontSize: 14 }}>{tip}</div>
    </div>
  );
}
